import { BasicFrame } from 'components/organisms';
import { ButtonActor, Card, Spacer, Text, Title } from 'components';
import { frameConfigBasic } from '../../AppConfig';
import { getFetchHeaders } from '../../utils/fetchHeaders';
import { getScreenTranslation } from '../../utils/translations';
import { InformationIcon, WarningGreyIcon } from 'components/icons';
import { LOGIN_ROUTE } from 'utils/constants';
import { logout } from 'actions/logout';
import { useEffect } from 'react';
import { useGetClientApplication } from '../../api';
import { useNavigateOrigin } from '../../hooks/useNavigateOrigin';
import { useTranslation } from 'react-i18next';
import classes from 'classnames';
import layout from 'scss/variables.module.scss';
import styles from './RegistrationRejected.module.scss';

export default function RegistrationRejected() {
  const { originRoute } = useNavigateOrigin();
  const { fetch: fetchGetApplication } = useGetClientApplication();
  const i18Next = useTranslation();

  useEffect(() => {
    const checkApplication = async () => {
      try {
        const application = await fetchGetApplication({
          headers: getFetchHeaders({
            Accept: 'application/vnd.4finance.web.v1.hal+json',
            'Content-Type': 'application/vnd.4finance.web.v1.hal+json',
          }),
        });
        if (
          application?.status === 'CLOSED' &&
          application?.resolutionDetail === 'NEW_OFFER'
        ) {
          window.location.replace(LOGIN_ROUTE);
        }
      } catch {
        console.error('Error checking application');
      }
    };
    checkApplication();
  }, []);

  const handleClick = () => {
    logout(originRoute);
  };

  const content = getScreenTranslation('requestDenied', i18Next);

  return (
    <BasicFrame
      {...frameConfigBasic}
      hideLogout
      contentLayoutClassName={layout['frame-x-compact']}
      contentWrapperClassName={layout['flex-column-centered']}
    >
      <Spacer
        className={layout['frame-x-padding']}
        marginBottom={{ default: '45px', m: '35px' }}
        paddingTop={{ s: '10px' }}
      >
        <Title icon={<WarningGreyIcon />} text={content.title} forceColumn />
      </Spacer>

      <Spacer marginBottom="60px" maxWidth="560px">
        <Card
          className={classes(styles['text-center'], layout['card-compact'])}
        >
          <Spacer padding={{ default: '25px 30px', xs: '20px' }}>
            <Card intent="success">
              <Spacer margin={{ default: '20px 60px', m: '20px 26px' }}>
                <span>{content.messageGreen}</span>
              </Spacer>
            </Card>
            <Spacer paddingTop="24px" paddingBottom="15px">
              <Spacer paddingVertical={'8px'}>
                <Text
                  className={styles['strong-text']}
                  weight="medium"
                  text={content.messageStrong}
                />
              </Spacer>

              <Text
                className={styles['helper-text']}
                text={content.messageSecondary}
                level={2}
                kind="p"
              />
            </Spacer>
          </Spacer>
        </Card>
      </Spacer>

      <Spacer
        className={classes(
          styles['container-three'],
          layout['frame-x-padding'],
        )}
      >
        <Spacer
          width="100%"
          marginBottom="50px"
          className={classes(styles['text-center'], layout['width-sm'])}
        >
          <ButtonActor
            buttonProps={{
              onClick: handleClick,
              className: styles['continue-button'],
            }}
          >
            {content.backBtn}
          </ButtonActor>
        </Spacer>

        <Spacer className={styles['frequent-causes']}>
          <span className={styles['frequent-causes-icon']}>
            <InformationIcon />
          </span>
          <Spacer className={styles['frequent-causes-text-wrapper']}>
            <Text
              className={styles['frequent-causes-title']}
              text={content.frequentCausesTitle}
            />
            {content.frequentCauses.map(
              (frequentCause: string, index: number) => (
                <Text
                  key={`frequent-cause-${index}`}
                  className={classes(
                    styles['frequent-causes-description'],
                    index === frequentCause.length - 1 &&
                      styles['frequent-causes-description-last'],
                  )}
                  text={`– ${frequentCause}`}
                  level={2}
                />
              ),
            )}
          </Spacer>
        </Spacer>
      </Spacer>
    </BasicFrame>
  );
}
